import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsAskfmComponent } from './simple-icons-askfm.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsAskfmComponent ],
    exports:      [ SimpleIconsAskfmComponent ],
    bootstrap:    []
})
export class SimpleIconsAskfmModule {}
